import { Link, useNavigate } from 'react-router-dom';
import { logout } from '../utils/authManager';

export default function AppNavbar({ currentUser, readCount }) {
  const navigate = useNavigate();
  const isAdmin = currentUser && ['admin@aenedu.site', 'vip@aenedu.site'].includes(currentUser.email);
  
  const handleLogout = () => {
    logout();
    navigate('/');
    window.location.reload();
  };
  
  return (
    <nav className="header-nav">
      <Link to="/" className="nav-link">首页</Link>
      <Link to="/subscription" className="nav-link">订阅中心</Link>
      
      {isAdmin && (
        <>
          <Link to="/manager" className="nav-link">文章管理</Link>
          <Link to="/admin" className="nav-link">管理后台</Link>
        </>
      )}
      
      {currentUser ? (
        <div className="user-info">
          <span className="user-name">👤 {currentUser.nickname}</span>
          {!isAdmin && <span className="read-count">已读 {readCount}/3篇</span>}
          {isAdmin && <span className="admin-badge">⚡ 管理员</span>}
          <button onClick={handleLogout} className="btn btn-outline btn-sm">退出</button>
        </div>
      ) : (
        <Link to="/auth" className="btn btn-primary btn-sm">登录/注册</Link>
      )}
    </nav>
  );
}